export default {"src":"/_next/static/media/values.e00f6c41.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};